import './About.css'
import React from "react";
import rectangle2 from '../assets/images/rectangle2.png';
import arrow from '../assets/images/arrow.png';
import butterflyHomePageStory from '../assets/images/butterflyHomePageStory.png';
import readHere from '../assets/images/readHere.png';
import CCBlurb from './components/CCBlurb.js'

function About(props) {
    return (
            <div className="aboutDetails">
                <div className="row">
                <div>
                    <img className="aboutRectangle" src={rectangle2} alt="rectangle"/>
                    <div className="aboutTextblock"> 
                        <div className="aboutTextHeaderDiv"></div>
                        <h2 className="aboutTextHeader"> who we are</h2>
                        <p className="aboutText"> 
                            Cerasus is an independent, female owned design studio based in Philadelphia, PA.
                        </p>
                        <div className="aboutTextHeaderDiv"></div>
                        <h2 className="aboutTextHeader"> what we do</h2>
                        <p className="aboutText"> 
                            Our specialty is digital assets - primarily typefaces and vintage inspired graphic sets. We also love branding work - we help brands establish themselves through custom typography and graphics for a unique and emblematic feel
                        </p>
                    </div>
                </div>
                <div className="ovalColumn">
                    <div className="longOvalButton topOvalButton"> 
                        <a href="/type" className="href">
                            <h1 className="ovalButtonText"> all type faces</h1>
                            <img className="aboutButtonArrow" src={arrow} alt="arrow pointing right"/>
                        </a>
                    </div>
                    <div className="longOvalButton"> 
                        <a href="/brands" className="href">
                            <h1 className="ovalButtonText ovalButtonText2"> some brand work</h1>
                            <img className="aboutButtonArrow" src={arrow} alt="arrow pointing right"/>
                        </a>
                    </div>
                </div>
                </div>
                <img className="butterflyHomePageStory" src={butterflyHomePageStory} alt="quick lesson on butterflies - Here at Cerasus, we adore everything about butterflies, from their historical symbolism to their wide array of colors, patterns, and structures." />
                <a href="story/butterflyLesson">
                    <img className="readHereImageButterfly" src={readHere} alt="read here wrapped in a vintage banner"/>
                </a>
                <CCBlurb learnMore={true}/>
            </div>
    )

}

export default About;